const initialState = {
    data: [],
  };
  
  const grupyReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_GRUPY':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default grupyReducer;